// JS file for Registration

import '@main';

$(() => {
  $('#input-user-address-city').attr('data-selected', u.data('user-city'));
  $('#input-user-address-dist').attr('data-selected', u.data('user-dist'));

  $('#input-user-address-wrapper').dk_tw_citySelector(
    '#input-user-address-city',
    '#input-user-address-dist'
  );

  $('#input-user-address-city').prop('required', true);
  $('#input-user-address-dist').prop('required', true);

  const password = $('#input-user-password');
  const password2 = $('#input-user-password2');

  password.on('input blur', (e) => {
    checkPassword(e.currentTarget);

    if (password2.val() !== '') {
      checkPassword2();
    }
  });

  password2.on('input blur', (e) => {
    checkPassword(e.currentTarget);
    checkPassword2();
  });

  $('#input-user-email').on('change input blur', (event) => {
    checkMail();
  })

  $('#input-user-username').on('change input blur', (event) => {
    checkValue($('#input-user-username'));
  })

  $('#input-user-gender').on('change input blur', (event) => {
    checkValue($('#input-user-gender'));
  })

  $('#input-user-birthday').on('change input blur', (event) => {
    checkValue($('#input-user-birthday'));
  })

  $('#input-user-education').on('change input blur', (event) => {
    checkValue($('#input-user-education'));
  })

  $('#input-user-mobile').on('change input blur', (event) => {
    checkValue($('#input-user-mobile'));
  })

  // show password
  $('.show-password').on('click', () => {
    showPassword(password, '.show-password');
  })

  // show password
  $('.show-confirm-password').on('click', () => {
    showPassword(password2, '.show-confirm-password');
  })

  if (u.data('message')) {
    const message = u.data('message')[0];

    const swalWithClass = Swal.mixin({
      customClass: {
        confirmButton: 'my-confirm-button'
      }
    })

    switch (message) {
      case 'password':
        swalWithClass.fire({
          title: '密碼不符',
          text: '密碼設定必須包含數字及大小寫字母字串',
          showCloseButton: true,
          confirmButtonText: '確定',
          confirmButtonColor: '#41a9a5',
        })
        break;

      case 'password_match':
        swalWithClass.fire({
          title: '密碼不符',
          text: '密碼與確認密碼輸入內容不相符',
          showCloseButton: true,
          confirmButtonText: '確定',
          confirmButtonColor: '#41a9a5',
        })
        break;

      case 'account_exists':
        swalWithClass.fire({
          title: '此帳號已存在',
          text: '請輸入其他電子信箱',
          showCloseButton: true,
          confirmButtonText: '確定',
          confirmButtonColor: '#41a9a5',
        })
        break;
    }
  }
});

const checkMail = () => {
  const mail = $('#input-user-email');
  const value = mail.val();

  if (value.indexOf('@') === -1) {
    mail.next('.invalid-tooltip').html('請在電子郵件地址中包含「@」。「' + value + '」未包含「@」。');
    mail.addClass('is-invalid');
    mail.removeClass('is-valid');
  } else {
    mail.addClass('is-valid');
    mail.removeClass('is-invalid');
  }
}

const checkPassword = (element) => {
  const password = $(element);
  const checkEight = password.parents('.j-password-wrapper').find('.password-check-eight');
  const checkWord = password.parents('.j-password-wrapper').find('.password-check-word');
  const value = password.val();
  password.next('.invalid-tooltip').html('密碼須包含英數字、大小寫，至少8個字元');

  if (value.match(/^[0-9a-zA-Z]{8,}$/)) {
    checkEight.removeClass('text-muted');
    checkEight.addClass('text-checked');
  } else {
    checkEight.addClass('text-muted');
    checkEight.removeClass('text-checked');
  }

  if (value.match(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z]{2,}$/)) {
    checkWord.removeClass('text-muted');
    checkWord.addClass('text-checked');
  } else {
    checkWord.addClass('text-muted');
    checkWord.removeClass('text-checked');
  }

  if (value.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/)) {
    password.addClass('is-valid');
    password.removeClass('is-invalid');
  } else {
    password.addClass('is-invalid');
    password.removeClass('is-valid');
  }
}

const checkPassword2 = () => {
  const password = $('#input-user-password');
  const password2 = $('#input-user-password2');

  if (password.val() !== password2.val()) {
    password2.next('.invalid-tooltip').html('密碼不符合');
    password2.addClass('is-invalid');
    password2.removeClass('is-valid');
  } else {
    password2.addClass('is-valid');
    password2.removeClass('is-invalid');
  }
}

const checkValue = debounce(
  (input) => {
    const valid = input[0].checkValidity();

    updateValidClass(input, valid);

    const wrapper = input.closest('[uni-field-validate]');

    wrapper.find('.invalid-tooltip').text(input[0].validationMessage);

    updateValidClass(wrapper.children(":first"), valid);

    const val = input.val();

    input.val(val + ' ');
    input.val(val);
  },
  300
);

function updateValidClass(ele, valid) {
  if (valid) {
    ele.removeClass('is-invalid');
    ele.addClass('is-valid');
  } else {
    ele.removeClass('is-valid');
    ele.addClass('is-invalid');
  }
}

const showPassword = (element, selector) => {
  if (element.attr('type') === 'password') {
    element.attr('type', 'text');

    $(selector + ' .fa-eye-slash').addClass('d-none');
    $(selector + ' .fa-eye').removeClass('d-none');
  } else {
    element.attr('type', 'password');

    $(selector + ' .fa-eye-slash').removeClass('d-none');
    $(selector + ' .fa-eye').addClass('d-none');
  }
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}
